import { atom } from "jotai";

export const isExampleDrawerOpen = atom(false);
